// @flow
import * as React from 'react'
import { isMobileBrowser } from '../../../utils'
import MobileSelectField from '../MobileSelectField'
import DesktopSelectField from '../DesktopSelectField'
import NativeSelectField from '../NativeSelectField'

// Types
import type { Props as DesktopSelectFieldProps } from '../DesktopSelectField'

export type Appearance = 'native' | 'mobile' | 'desktop'
export type Props = DesktopSelectFieldProps & {
  fieldAppearance?: Appearance,
  innerRef?: (ref: ?DesktopSelectField) => any,
}

// Constants
const APPEARANCES = {
  native: NativeSelectField,
  mobile: MobileSelectField,
  desktop: DesktopSelectField,
}

/**
 * Select field that adapts the appearance based on given `selectPppearance` prop
 * and current device.
 * @return {React.Element}
 */
const AdaptiveSelectField = ({
  fieldAppearance,
  innerRef,
  focusableRef,
  ...restProps
}: Props) => {
  let SelectFieldComponent = DesktopSelectField
  if (fieldAppearance) {
    SelectFieldComponent = APPEARANCES[fieldAppearance] || APPEARANCES.desktop
  } else if (isMobileBrowser()) {
    SelectFieldComponent = APPEARANCES.mobile
  } else {
    SelectFieldComponent = APPEARANCES.desktop
  }
  return (
    <SelectFieldComponent
      {...restProps}
      ref={innerRef}
      focusableRef={focusableRef}
    />
  )
}

AdaptiveSelectField.defaultProps = DesktopSelectField.defaultProps

export default AdaptiveSelectField
